app.controller("profilePhotosController", ["$scope", "StaticData", "ImageChange", "$stateParams", "$state", "usSpinnerService", "ConfirmModal",
    function ($scope, StaticData, ImageChange, $stateParams, $state, usSpinnerService, ConfirmModal) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };

            usSpinnerService.spin("root");
            ImageChange.list({page: page, limit: $scope.itemsPerPage}).then(function (data) {
                $scope.requests = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb()
            });

        }

        $scope.apply = function (request, $event) {
            ConfirmModal.show({
                title: "დაშვება",
                message: "გსურთ ამ პროფილის სურათის დაშვება?"
            }).result.then(function () {
                ImageChange.prove(request._id).then(function () {
                    loadPage($scope.currentPage);
                    toastr.success('პროფილის სურათი შეცვლილია წარმატებით');
                })
            });
        };

        $scope.deny = function (request, $event) {
            ConfirmModal.show({
                title: "უარყოფა",
                message: "არ გსურთ ამ პროფილის სურათის დაშვება?"
            }).result.then(function () {
                ImageChange.deny(request._id).then(function () {
                    loadPage($scope.currentPage);
                    toastr.success('პროფილის სურათი უარყოფილია');
                })
            });
        };
    }
]);